import { z } from "zod";

export const agreeOnTerms = z
  .boolean()
  .refine((value) => value === true, "You have to agree on terms");
